module.exports = __webpack_public_path__ + "img/girl6.3825aa6a.jpg";